var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      attrs: { "data-vv-scope": "worker-information-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-4 col-md-12" },
          [
            _c(
              "b-form-group",
              [
                _c("ListGroups", {
                  attrs: {
                    name: "UNIDAD_DESEMPENO_ID",
                    "data-cy": "performance-unit",
                    autocomplete: "",
                    label: "Unidad de desempeño",
                    typeList: _vm.stepType
                  },
                  on: { input: _vm.agregarUnidad },
                  model: {
                    value: _vm.form.UNIDAD_DESEMPENO_ID,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "UNIDAD_DESEMPENO_ID", $$v)
                    },
                    expression: "form.UNIDAD_DESEMPENO_ID"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-4 col-md-12" },
          [
            _c(
              "b-form-group",
              [
                _c("ListUser", {
                  attrs: {
                    name: "jefatura_responsable",
                    label: "Jefatura responsable",
                    "data-cy": "responsible-leadership",
                    autocomplete: "",
                    placeholder: "Seleccione un usuario"
                  },
                  on: { input: _vm.agregarJefatura },
                  model: {
                    value: _vm.form.JEFATURA_ID,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "JEFATURA_ID", $$v)
                    },
                    expression: "form.JEFATURA_ID"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-4 col-md-12" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Cargo jefatura",
                  "data-cy": "leadership-position"
                }
              },
              [
                _c("b-form-input", {
                  attrs: { maxlength: "99" },
                  model: {
                    value: _vm.form.JEFATURA_CARGO,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "JEFATURA_CARGO", $$v)
                    },
                    expression: "form.JEFATURA_CARGO"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-4 col-sm-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Tipo de jornada", "data-cy": "type-of-day" } },
              [
                _c("b-form-input", {
                  attrs: { maxlength: "99" },
                  model: {
                    value: _vm.form.JORNADA,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "JORNADA", $$v)
                    },
                    expression: "form.JORNADA"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-4 col-sm-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Cargo", "data-cy": "company-position" } },
              [
                _c("b-form-input", {
                  attrs: { maxlength: "99" },
                  model: {
                    value: _vm.form.CARGO,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "CARGO", $$v)
                    },
                    expression: "form.CARGO"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-4 col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Grado", "data-cy": "grade-position" } },
              [
                _c("b-form-input", {
                  attrs: { maxlength: "99" },
                  model: {
                    value: _vm.form.GRADO,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "GRADO", $$v)
                    },
                    expression: "form.GRADO"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-4 col-sm-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Departamento", "data-cy": "department" } },
              [
                _c("b-form-input", {
                  attrs: { maxlength: "99" },
                  model: {
                    value: _vm.form.DEPARTAMENTO,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "DEPARTAMENTO", $$v)
                    },
                    expression: "form.DEPARTAMENTO"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-4 col-sm-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Rol", "data-cy": "role" } },
              [
                _c("b-form-input", {
                  attrs: { maxlength: "150" },
                  model: {
                    value: _vm.form.ROL,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ROL", $$v)
                    },
                    expression: "form.ROL"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-form-group",
              {
                attrs: { label: "Funciones del cargo", "data-cy": "functions" }
              },
              [
                _c("b-form-tags", {
                  attrs: {
                    "remove-on-delete": "",
                    placeholder: "Escriba la funcion y presione enter",
                    addButtonText: "Agregar"
                  },
                  model: {
                    value: _vm.form.FUNCIONES,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "FUNCIONES", $$v)
                    },
                    expression: "form.FUNCIONES"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 text-center" },
          [
            _c(
              "vs-button",
              {
                staticClass: "mt-3 mb-5",
                attrs: { "data-cy": "save", color: "primary", type: "border" },
                on: {
                  click: function($event) {
                    return _vm.onSubmit()
                  }
                }
              },
              [
                _vm._v(" GUARDAR CAMBIOS "),
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass:
                    "spinner-border spinner-border-sm text-white ml-1 mb-1"
                })
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }